import { withSvgIcon } from './withSvgIcon';

export const Bell = withSvgIcon(
  <>
    <path
      d="M6.5 9.5C6.5 4.7 8.99992 3 12 3C15 3 17.5 4.7 17.5 9.5C17.5 12.0123 19.2533 15.3234 19.8233 17.0204C19.9991 17.5439 19.5522 18 19 18H4.99996C4.44768 18 4.00081 17.5439 4.17666 17.0204C4.74667 15.3234 6.5 12.0123 6.5 9.5Z"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinejoin="round"
    />
    <path
      d="M10 21H14"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="square"
      strokeLinejoin="round"
    />
  </>,
  { viewBox: '0 0 24 24' },
);
